<div class="modal-header">
    Connection error
</div>
<div class="modal-body">
    <p>An error has occured and the session has been disconnected. Please refresh the page.</p>
    <p>The changes in your document will be preserved.</p>
</div>